<template>
  <section style="padding: 1.5em">
    <div class="row">
      <div class="col-md-1">
        <label>Show Records</label>
        <select class="form-control h-43" v-model="showRecords">
          <option value="10">10</option>
          <option value="30">30</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
      <template v-if="type !== 'finished'">
        <div class="col-md-3">
          <label>Search By Domain / Email</label>
          <input v-model="searchQuery" type="text" class="form-control h-43" placeholder="example.com" />
        </div>
      </template>
      <template v-else>
        <div class="col-md-3">
          <label>Search By Domain / Email</label>
          <input @keyup.enter="$parent.getUpdatedData()" v-model="searchQuery" type="text" class="form-control h-43" placeholder="example.com" />
        </div>
        <div class="col-md-1 mt-5">
          <div class="form-check-radio mb-9">
            <label class="form-check-label">
              <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="domain" value="domain"> Domain
              <span class="form-check-sign"></span>
            </label>
          </div><div class="form-check-radio">
          <label class="form-check-label">
            <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="email" value="email"> Email
            <span class="form-check-sign"></span>
          </label>
        </div>

        </div>
        <div class="col-md-3 d-flex align-items-center">
          <button
              class="btn btn-primary mt-22 btn-sm"
              v-on:click="$parent.getUpdatedData()"
          >
            Search
          </button>
        </div>
      </template>
      <div v-if="type === 'review'|| type === 'active'" class="col-md-8">
        <button class="btn btn-success pull-right" :disabled="updatingCF" @click="updateReviewCFStatus">
              <span v-if="updatingCF">
               <div class="loader" style="width: 20px;height: 20px; margin: 0 auto !important;"></div>
              </span>
          <span v-else>
              Update CF Status
              </span>
        </button>
      </div>
    </div>
    <div v-if="!asyncDone" class="customer-list-info"  >
      <div class="loader">
      </div>
    </div>
    <div v-else class="row">
      <div class="col-md-12">
        <div class="accordion mt-3" id="accordionExample">
          <div v-for="(migration, index) in filteredTasks" :key="'migrations_' + index" class="card card-body domain-card">
            <div class="media d-flex align-items-center">
              <button class="btn btn-sm btn-primary my-0 mr-4" data-toggle="collapse" :data-target="'#collapse_' + type + migration.docId" :aria-controls="'collapse' + type  +  migration.docId" @click="openTab(migration)"><i class="fa fa-plus"></i></button>
              <div class="media-body">
                <div class="domain-head  d-flex align-items-center">
                  <h5 class="mt-1 h5-m0">
                    <a :href="'https://' + migration.siteDetails.domainName" target="_blank" class="mr-2">{{migration.siteDetails.domainName}}</a><i class="fa fa-copy text-primary ml-5 mr-5 cursor-pointer" @click="doCopy(migration.siteDetails.domainName)" />
                    <small><span class="fs-10 badge mr-2" :class="{'badge-danger' : migration.status === 'pending' || migration.status === 'review' || migration.status === 'abandoned', 'badge-success' : migration.status === 'finished'}">
                                         {{(migration.status !== 'finished' && migration.customStatus) ? migration.customStatus : migration.status}}
                                         <a href="javascript:void(0)" v-if="migration.status !== 'finished'" @click="changeCustomStatus(migration)" class="fa fa-pencil text-white"></a>
                                       </span></small>
                    <small><a @click="doCopy(migration.email)" href="javascript:void(0)" class="fs-10 badge badge-info"><i class="fa fa-copy"></i> {{ migration.email }}</a></small>
                    <small v-if="migration.tagCategories && migration.tagCategories.length>0"><span v-for="(row, index) in migration.tagCategories" :key="index" class="fs-10 badge ml-2 badge-danger cursor-pointer" >{{row.category}}:{{ row.tag }}</span>
                    </small>
                  </h5>
                  <section>
                    <ul class="list-inline ul-m0">
                      <li v-if="migration.handledBy === ''" @click="checkInMigration(migration)" class="list-inline-item"><button class="btn btn-sm btn-primary">CheckIn</button></li>
                      <li v-else class="list-inline-item" >
                                               <span class="badge badge-info">
                                                   Handled By {{migration.handledBy}}
                                                   <a href="javascript:void(0)" v-if="migration.status === 'pending'" @click="checkOutMigration(migration)" class="fa fa-times text-white"></a>
                                               </span>
                      </li>
                      <li @click="goToNuxt(migration.uid, 'migration')" class="list-inline-item" title="Login as user"><button class="btn btn-sm btn-primary"><i class="fa fa-user"></i></button></li>
                      <li v-if="migration.ticketId" @click="viewTicket(migration)" class="list-inline-item" title="View Ticket"><button class="btn btn-sm btn-primary"><i class="fa fa-eye"></i></button></li>
                      <li @click="openTempDomainModal(migration)" class="list-inline-item" title="Temporary Domain"><button class="btn btn-sm btn-info"><i class="fa fa-link"></i></button></li>
                      <li @click="openNotesModal(migration)" class="list-inline-item"><button class="btn btn-sm btn-default"> <i  v-if="migration.status !== 'finished'" class="fa" :class="(migration.notes && migration.notes.length > 0) ? 'fa-pencil' : 'fa-plus'"></i> Notes</button></li>
                      <li class="list-inline-item text-center cf-status-icons">
                        <i class="btn btn-link" :title="(migration.cloudflare.ssl === 'full') ? 'SSL - FULL' : (migration.cloudflare.ssl === 'flexible') ? 'SSL - FLEXIBLE' : 'SSL - Not Active'"
                           :class="{'fa fa-lock disabled' : (migration.cloudflare.ssl ===  false || migration.cloudflare.ssl ===  undefined),
                                                    'fa fa-lock mr-3 enabled' : migration.cloudflare.ssl === 'full',
                                                    'fa fa-lock mr-3 yellow' : migration.cloudflare.ssl === 'flexible'}"></i>
                      </li>
                      <li class="list-inline-item text-center cf-status-icons">
                        <i class="btn btn-link" :title="(migration.cloudflare.cf === 'paused') ? 'CF - Paused' : (migration.cloudflare.cf === true) ? 'CF - Active & Un-Paused'  : 'CF - Not Active'"
                           :class="{'fa fa-cloud disabled' : (migration.cloudflare.cf === undefined || migration.cloudflare.cf === false),
                                                    'fa fa-cloud yellow' : migration.cloudflare.cf === 'paused',
                                                    'fa fa-cloud enabled': migration.cloudflare.cf === true}"></i>
                      </li>
                    </ul>
                  </section>
                </div>
              </div>
            </div>
            <div :id="'collapse_' + type  +  migration.docId" class="collapse"    data-parent="#accordionExample" >
              <div class="card-body">

                <form @submit.prevent="finishMigration(migration, index)">
                  <div class="row">
                    <div class="col-md-12">
                      <section v-if="migration.notes && migration.notes.length > 0" class="notes-section">
                        <h5 class=""><b>Added Notes</b></h5>
                        <div  class="row">
                          <div :class="(migration.status !== 'finished' && migration.status !== 'pending') ? 'col-md-4' : 'col-md-6'">
                            <dl>
                              <dt>Note</dt>
                            </dl>
                          </div>
                          <div class="text-center col-md-2">
                            <dl>
                              <dt>Added By</dt>
                            </dl>
                          </div>
                          <div class="col-md-2 text-center">
                            <dl>
                              <dt>Completed By</dt>
                            </dl>
                          </div>
                          <div class="col-md-2 text-center" v-if="migration.status !== 'pending'">
                            <dl>
                              <dt>Reviewed By</dt>
                            </dl>
                          </div>
                          <div class="col-md-2" v-if="migration.status !== 'finished'">
                            <dl>
                              <dt class="pull-right">Action</dt>
                            </dl>
                          </div>
                        </div>
                        <div class="row" v-for="(note, note_index) of migration.notes" :key="'notes_'+note_index">
                          <div :class="(migration.status !== 'finished' && migration.status !== 'pending') ? 'col-md-4' : 'col-md-6'" >
                            <dl>
                              <dd>
                                <span v-html="getText(note.text)"></span>
                              </dd>
                              <dd><a v-if="note.imageUrl" :href="note.imageUrl" target="_blank"><i class="fa fa-paperclip" aria-hidden="true"></i>View Attachment</a></dd>
                            </dl>
                          </div>
                          <div class="text-center col-md-2">
                            <dl>
                              <dd>{{ note.addedBy }}</dd>
                            </dl>
                          </div>
                          <div class="col-md-2 text-center">
                            <div v-if="migration.status === 'pending' && !note.completedBy" class="custom-control custom-checkbox p mr-sm-2">
                              <input type="checkbox" required  :disabled="migration.status !== 'pending'" @change="acknowledgeNote(migration, note, 'complete')" class="custom-control-input" :id="'notes'+ index + note_index + 'complete-ackNotes'"/>
                              <label class="custom-control-label pt-1" :for="'notes' + index + note_index + 'complete-ackNotes'"></label>
                            </div>
                            <div v-else>
                              <span class="badge badge-primary text-center">{{(note.completedBy) ? note.completedBy : 'Acknowledged'}}</span>
                            </div>
                          </div>
                          <div class="col-md-2 text-center" v-if="migration.status !== 'pending'">
                            <div v-if="migration.status === 'review' && !note.reviewedBy" class="custom-control custom-checkbox p mr-sm-2">
                              <input type="checkbox" required :disabled="migration.status !== 'review'" @change="acknowledgeNote(migration, note, 'review')" class="custom-control-input" :id="'notes'+ index + note_index + 'review-ackNotes'"/>
                              <label class="custom-control-label pt-1" :for="'notes'+ index + note_index + 'review-ackNotes'"></label>
                            </div>
                            <div v-else>
                              <span class="badge badge-primary text-center">{{(note.reviewedBy) ? note.reviewedBy : 'Acknowledged'}}</span>
                            </div>
                          </div>
                          <div class="col-md-2" v-if="migration.status !== 'finished'">
                            <button type="button" class="btn btn-sm btn-danger my-1 pull-right" @click="deleteMigrationNote(migration.notes, migration.docId, note_index)"><i class="fa fa-trash"></i></button>
                          </div>
                          <div class="col-md-12" v-if="note_index < migration.notes.length-1">
                            <hr>
                          </div>
                        </div>
                      </section>
                      <hr v-if="migration.notes && migration.notes.length > 0" class="h-3">
                      <h5 class=""><b>Primary Plan: </b> {{ migration.primaryPlan }}
                        <small><a href="javascript:void(0)" class="fs-10 badge badge-info"> {{ formattedDate(migration.created) }}</a></small>
                        <small v-if="migration.handledBy && migration.ticketId" :title="migration.notifyUser ? 'Customer has been notified' : 'Notify customer that you have started working on his migration.'">

                          <button type="button" :disabled="loading || notifying === migration.ticketId  || type === 'finished' || type === 'abandoned'" @click="notifyUser(migration, migration.notifyUser)" class="btn btn-sm btn-success" style="float:right;">
                            <i class="fa" :class="(notifying === migration.ticketId)? 'fa-spinner fa-spin' : 'fa-bell'" />
                          </button>
                          <button type="button"  @click="openPsiModal(migration.siteDetails.domainName)" class="btn btn-sm btn-info" style="float:right;">
                            View PSI
                          </button>
                        </small>
                      </h5>
                      Moved to {{type}}: <small v-if="migration.movedAt"><a href="javascript:void(0)" class="fs-10 badge badge-primary">{{formattedDate(migration.movedAt) }}</a></small>

                      <hr class="h-3">
                      <h5 class=""><b>Site Details</b></h5>
                      <div class="row">
                        <!--                                           <div class="col-md-3">-->
                        <!--                                               <dl>-->
                        <!--                                                   <dt>Domain Name</dt>-->
                        <!--                                                   <dd>{{ migration.siteDetails.domainName }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.domainName)"><i class="fa fa-copy"></i></a></dd>-->
                        <!--                                               </dl>-->
                        <!--                                           </div>-->
                        <div class="col-md-3">
                          <dl>
                            <dt>Current Host</dt>
                            <dd>{{ migration.siteDetails.currentHost }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.currentHost)"><i class="fa fa-copy"></i></a></dd>
                          </dl>
                        </div>
                        <div class="col-md-3">
                          <dl>
                            <dt>Hosting Panel Login</dt>
                            <dd><a class="mr-1" target="_blank" :href="getLink(migration.siteDetails.hostingPanelLogin)">{{migration.siteDetails.hostingPanelLogin}}</a> <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.hostingPanelLogin)"><i class="fa fa-copy"></i></a></dd>
                          </dl>
                        </div>
                        <div class="col-md-3">
                          <dl>
                            <dt>Hosting Panel User</dt>
                            <dd>{{ migration.siteDetails.hostingPanelUsername }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.hostingPanelUsername)"><i class="fa fa-copy"></i></a></dd>

                          </dl>
                        </div>
                        <div class="col-md-3">
                          <dl>
                            <dt>Hosting Panel Password</dt>
                            <dd>{{ migration.siteDetails.hostingPanelPassword }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.hostingPanelPassword)"><i class="fa fa-copy"></i></a></dd>
                          </dl>
                        </div>
                      </div>
                      <hr>
                      <div class="row">
                        <div class="col-md-3">
                          <dl>
                            <dt>Wordpress Admin Login</dt>
                            <dd><a class="mr-1" target="_blank" :href="migration.siteDetails.wpAdminLogin">{{migration.siteDetails.wpAdminLogin}}</a> <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.wpAdminLogin)"><i class="fa fa-copy"></i></a></dd>
                          </dl>
                        </div>
                        <div class="col-md-3">
                          <dl>
                            <dt>Wordpress Admin Username</dt>
                            <dd>{{ migration.siteDetails.wpAdminUsername }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.wpAdminUsername)"><i class="fa fa-copy"></i></a></dd>
                          </dl>
                        </div>
                        <div class="col-md-3">
                          <dl>
                            <dt>Wordpress Admin Password</dt>
                            <dd>{{ migration.siteDetails.wpAdminPassword }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.wpAdminPassword)"><i class="fa fa-copy"></i></a></dd>

                          </dl>
                        </div>
                      </div>
                      <hr :class="{'h-3' : !migration.siteDetails.isSSH}">
                      <div class="row" v-if="migration.siteDetails.isSSH">
                        <div class="col-md-3">
                          <dt>SSH IP</dt>
                          <dd>{{ migration.siteDetails.sshIP }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.sshIP)"><i class="fa fa-copy"></i></a></dd>
                        </div>
                        <div class="col-md-3">
                          <dt>SSH Port</dt>
                          <dd>{{ migration.siteDetails.sshPort }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.sshPort)"><i class="fa fa-copy"></i></a></dd>
                        </div>
                        <div class="col-md-3">
                          <dt>SSH Username</dt>
                          <dd>{{ migration.siteDetails.sshUsername }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.sshUsername)"><i class="fa fa-copy"></i></a></dd>
                        </div>
                        <div class="col-md-3">
                          <dt>SSH Password</dt>
                          <dd>{{ migration.siteDetails.sshPassword }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.sshPassword)"><i class="fa fa-copy"></i></a></dd>
                        </div>
                      </div>
                      <h5 class=""><b>Domain Details</b></h5>
                      <div class="row">
                        <div class="col-md-3">
                          <template v-if="migration.domainDetails.handleDNS">
                            <dl>
                              <dt>Current Domain Registrar</dt>
                              <dd>{{ migration.domainDetails.domainRegistrarDetails.currentHost }} <a href="javascript:void(0)" @click="doCopy(migration.domainDetails.domainRegistrarDetails.currentHost)"><i class="fa fa-copy"></i></a></dd>
                            </dl>
                          </template>
                          <template v-else>
                            <p class="text-danger">User will manage his own DNS changes!</p>
                          </template>
                        </div>
                        <div class="col-md-3" v-if="migration.domainDetails.handleDNS">
                          <dl>
                            <dt>Domain Registrar URL</dt>
                            <dd><a class="mr-1" target="_blank" :href="getLink(migration.domainDetails.domainRegistrarDetails.hostingPanelLogin)">{{migration.domainDetails.domainRegistrarDetails.hostingPanelLogin}}</a> <a href="javascript:void(0)" @click="doCopy(migration.domainDetails.domainRegistrarDetails.hostingPanelLogin)"><i class="fa fa-copy"></i></a></dd>
                          </dl>
                        </div>
                        <div class="col-md-3" v-if="migration.domainDetails.handleDNS">
                          <dl>
                            <dt>Domain Registrar Username</dt>
                            <dd>{{ migration.domainDetails.domainRegistrarDetails.hostingPanelUsername }} <a href="javascript:void(0)" @click="doCopy(migration.domainDetails.domainRegistrarDetails.hostingPanelUsername)"><i class="fa fa-copy"></i></a></dd>
                          </dl>
                        </div>
                        <div class="col-md-3" v-if="migration.domainDetails.handleDNS">
                          <dl>
                            <dt>Domain Registrar Password</dt>
                            <dd>{{ migration.domainDetails.domainRegistrarDetails.hostingPanelPassword }} <a href="javascript:void(0)" @click="doCopy(migration.domainDetails.domainRegistrarDetails.hostingPanelPassword)"><i class="fa fa-copy"></i></a></dd>
                          </dl>
                        </div>
                      </div>
                      <hr class="h-3">
                      <div class="row">
                        <div class="col-md-3 pr-0 has-text-centered">
                          <h5 class=""><b>Additional Details</b></h5>
                        </div>
                        <div class="col-md-9 text-left row">
                          <div v-if="migration.status === 'pending' && ( !migration.ackAdditionalDetail || ( migration.ackAdditionalDetail && !migration.ackAdditionalDetail.completedBy))" class="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" required @change="acknowledge(migration, 'additional_detail')" class="custom-control-input" :id="'m' + index + 'complete-additional-detail'"/>
                            <label class="custom-control-label" :for="'m' + index + 'complete-additional-detail'"></label>
                          </div>
                          <div v-else>
                            <span class="badge badge-primary">{{(migration.ackAdditionalDetail && migration.ackAdditionalDetail.completedBy) ? migration.ackAdditionalDetail.completedBy : 'Acknowledged'}}</span>
                          </div>
                          <div v-if="migration.status !== 'pending' && ( migration.ackAdditionalDetail && !migration.ackAdditionalDetail.reviewedBy)" class="custom-control custom-checkbox p mr-sm-2 ml-2">
                            <input type="checkbox" required @change="acknowledge(migration, 'additional_detail')" class="custom-control-input" :id="'m' + index + 'review-additional-detail'"/>
                            <label class="custom-control-label pt-1" :for="'m' + index + 'review-additional-detail'"></label>
                          </div>
                          <div v-else-if="migration.status !== 'pending'" class="ml-2">
                            <span class="badge badge-primary">{{(migration.ackAdditionalDetail && migration.ackAdditionalDetail.reviewedBy) ? migration.ackAdditionalDetail.reviewedBy : 'Acknowledged'}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <dl>
                            <dt>Have Cloudflare, Sucuri or Other DNS/CDN Account?</dt>
                            <dd>{{ migration.additionalDetails.isCF ? 'Yes' : 'No' }}</dd>
                          </dl>
                        </div>
                        <div class="col-md-3">
                          <dl>
                            <template v-if="migration.additionalDetails.isCF">
                              <dt>DNS / CDN Service</dt>
                              <dd>{{ migration.additionalDetails.cdnType }} <a href="javascript:void(0)" @click="doCopy(migration.additionalDetails.cdnType)"><i class="fa fa-copy"></i></a></dd>
                              <dd v-if="migration.additionalDetails.cdnType === 'Other' && migration.additionalDetails.url"> <a :href="migration.additionalDetails.url" class="mr-2" target="_blank">{{ migration.additionalDetails.url }}</a><a href="javascript:void(0)" @click="doCopy(migration.additionalDetails.url)"><i class="fa fa-copy"></i></a></dd>
                            </template>
                            <template v-if="!migration.additionalDetails.isCF">
                              <dl>
                                <dt>Special .htaccess or nginx rewrite rules?</dt>
                                <dd v-if="!migration.additionalDetails.isWebsiteRedirectsAvailable">N/A</dd>
                                <dd v-else>

                                  <span v-html="getText(migration.additionalDetails.websiteRedirects)"></span>
                                  <a href="javascript:void(0)"  class="ml-1" @click="doCopy(migration.additionalDetails.websiteRedirects)"><i class="fa fa-copy"></i></a></dd>
                              </dl>
                            </template>
                          </dl>
                        </div>
                        <div class="col-md-3">
                          <dl>
                            <template v-if="migration.additionalDetails.isCF">
                              <dt>Cloudflare Username</dt>
                              <dd>{{ migration.additionalDetails.cfUsername }} <a href="javascript:void(0)" @click="doCopy(migration.additionalDetails.cfUsername)"><i class="fa fa-copy"></i></a></dd>
                            </template>
                          </dl>
                        </div>
                        <div class="col-md-3">
                          <dl>
                            <template v-if="migration.additionalDetails.isCF">
                              <dt>Cloudflare Password</dt>
                              <dd>{{ migration.additionalDetails.cfPassword }} <a href="javascript:void(0)" @click="doCopy(migration.additionalDetails.cfPassword)"><i class="fa fa-copy"></i></a></dd>
                            </template>
                          </dl>
                        </div>
                      </div>
                      <hr>
                      <div class="row" >
                        <div class="col-md-12">
                          <dl>
                            <dt>Any other special instructions?</dt>
                            <dd v-if="migration.additionalDetails.specialInstructions === '' || migration.additionalDetails.specialInstructions === 'N/A'">N/A</dd>
                            <dd v-else>
                              <span v-html="getText(migration.additionalDetails.specialInstructions)" />
                              <a href="javascript:void(0)" class="ml-1" @click="doCopy(migration.additionalDetails.specialInstructions)">
                                <i class="fa fa-copy"></i>
                              </a><br>
                              <section>
                                <div v-if="migration.status === 'pending' && ( !migration.ackNotes || ( migration.ackNotes && !migration.ackNotes.completedBy))" class="custom-control custom-checkbox p mr-sm-2">
                                  <input type="checkbox" required @change="acknowledge(migration, 'ackNotes')" class="custom-control-input" :id="'m' + index + 'complete-ackNotes'"/>
                                  <label class="custom-control-label pt-1" :for="'m' + index + 'complete-ackNotes'"></label>
                                </div>
                                <div v-else>
                                  <span class="badge badge-primary">{{(migration.ackNotes && migration.ackNotes.completedBy) ? migration.ackNotes.completedBy : 'Acknowledged'}}</span>
                                </div>
                                <div v-if="migration.status !== 'pending' && migration.ackNotes && !migration.ackNotes.reviewedBy" class="custom-control custom-checkbox p mr-sm-2">
                                  <input type="checkbox" required @change="acknowledge(migration, 'ackNotes')" class="custom-control-input" :id="'m' + index + 'review-ackNotes'"/>
                                  <label class="custom-control-label pt-1" :for="'m' + index + 'review-ackNotes'"></label>
                                </div>
                                <div v-else-if="migration.status !== 'pending'">
                                  <span class="badge badge-primary">{{(migration.ackNotes && migration.ackNotes.reviewedBy) ? migration.ackNotes.reviewedBy : 'Acknowledged'}}</span>
                                </div>
                              </section>
                              <!--                                                     <a href="javascript:void(0)" class="badge badge-primary cursor-pointer" title="Click to Acknowledge" v-if="migration.status === 'pending' && !migration.ackNotes" @click="acknowledge(migration.docId, 'ackNotes')">-->
                              <!--                                                       <i class="fa fa-check"></i>-->
                              <!--                                                     </a>-->
                              <!--                                                     <span v-else>(Clients Notes checked)</span>-->
                            </dd>
                          </dl>
                        </div>
                      </div>
                      <hr>
                      <div class="row">
                        <div class="col-md-4" v-if="migration.additionalDetails.isCF">
                          <dl>
                            <dt>Special .htaccess or nginx rewrite rules?</dt>
                            <dd v-if="!migration.additionalDetails.isWebsiteRedirectsAvailable">N/A</dd>
                            <dd v-else>
                              <span v-html="getText(migration.additionalDetails.websiteRedirects)"></span>
                              <a href="javascript:void(0)" @click="doCopy(migration.additionalDetails.websiteRedirects)"><i class="fa fa-copy"></i></a></dd>
                          </dl>
                        </div>
                        <div class="col-md-4">
                          <dl>
                            <dt>MEMBERSHIP or E-COMMERCE?</dt>
                            <dd>
                              {{(migration.additionalDetails.membershipOrECommerce) ? 'Yes' : 'No'}}
                              <section v-if="migration.additionalDetails.membershipOrECommerce">
                                <div v-if="migration.status === 'pending' && ( !migration.ackMembership || ( migration.ackMembership && !migration.ackMembership.completedBy))" class="custom-control custom-checkbox p mr-sm-2">
                                  <input type="checkbox" required @change="acknowledge(migration, 'membership')" class="custom-control-input" :id="'m' + index + 'complete-membership'"/>
                                  <label class="custom-control-label pt-1" :for="'m' + index + 'complete-membership'"></label>
                                </div>
                                <div v-else>
                                  <span class="badge badge-primary">{{(migration.ackMembership && migration.ackMembership.completedBy) ? migration.ackMembership.completedBy : 'Acknowledged'}}</span>
                                </div>
                                <div v-if="migration.status !== 'pending' && ( migration.ackMembership && !migration.ackMembership.reviewedBy)" class="custom-control custom-checkbox p mr-sm-2">
                                  <input type="checkbox" required @change="acknowledge(migration, 'membership')" class="custom-control-input" :id="'m' + index + 'review-membership'"/>
                                  <label class="custom-control-label pt-1" :for="'m' + index + 'review-membership'"></label>
                                </div>
                                <div v-else-if="migration.status !== 'pending'">
                                  <span class="badge badge-primary">{{(migration.ackMembership && migration.ackMembership.reviewedBy) ? migration.ackMembership.reviewedBy : 'Acknowledged'}}</span>
                                </div>
                              </section>
                              <!--                                                       <a href="javascript:void(0)" class="badge badge-primary cursor-pointer" title="Click to Acknowledge" v-if="migration.status === 'pending' && !migration.ackMembership" @click="acknowledge(migration.docId, 'membership')">-->
                              <!--                                                           <i class="fa fa-check"></i>-->
                              <!--                                                       </a>-->
                              <!--                                                       <span v-if="migration.ackMembership">(Acknowledged)</span>-->
                            </dd>
                          </dl>
                        </div>
                        <div class="col-md-4">
                          <dl>
                            <dt>Assigned Collaborators</dt>
                            <dd v-if="migration.additionalDetails.collaborators && migration.additionalDetails.collaborators.length > 0">
                              <span v-for="collaborator in migration.additionalDetails.collaborators" class="badge badge-primary mr-2">{{collaborator}}</span>
                              <section>
                                <div v-if="migration.status === 'pending' && ( !migration.ackCollaborator || ( migration.ackCollaborator && !migration.ackCollaborator.completedBy))" class="custom-control custom-checkbox p mr-sm-2">
                                  <input type="checkbox" required @change="acknowledge(migration, 'collaborator')" class="custom-control-input" :id="'m' + index + 'complete-collaborator'"/>
                                  <label class="custom-control-label pt-1" :for="'m' + index + 'complete-collaborator'"></label>
                                </div>
                                <div v-else>
                                  <span class="badge badge-primary">{{(migration.ackCollaborator && migration.ackCollaborator.completedBy) ? migration.ackCollaborator.completedBy : 'Acknowledged'}}</span>
                                </div>
                                <div v-if="migration.status !== 'pending' && ( migration.ackCollaborator && !migration.ackCollaborator.reviewedBy)" class="custom-control custom-checkbox p mr-sm-2">
                                  <input type="checkbox" required @change="acknowledge(migration, 'collaborator')" class="custom-control-input" :id="'m' + index + 'review-collaborator'"/>
                                  <label class="custom-control-label pt-1" :for="'m' + index + 'review-collaborator'"></label>
                                </div>
                                <div v-else-if="migration.status !== 'pending'">
                                  <span class="badge badge-primary">{{(migration.ackCollaborator && migration.ackCollaborator.reviewedBy) ? migration.ackCollaborator.reviewedBy : 'Acknowledged'}}</span>
                                </div>
                              </section>
                              <!--                                                       <a href="javascript:void(0)" class="badge badge-primary cursor-pointer " title="Click to Acknowledge"  v-if="migration.status === 'pending' && !migration.ackCollaborator" @click="acknowledge(migration.docId, 'collaborator')">-->
                              <!--                                                           <i class="fa fa-check"></i>-->
                              <!--                                                       </a>-->
                              <!--                                                       <span v-else class="d-block">(Collaborators were reviewed, and communicated with or considered)</span>-->
                            </dd>
                            <dd v-else>
                              <span class="d-block">N/A</span>
                            </dd>
                          </dl>
                        </div>
                      </div>
                      <hr class="h-3">
                      <h5 class=""><b>Email Details</b></h5>
                      <div class="row">
                        <div class="col-md-4">
                          <dl>
                            <dt>Wants BigScoots to host email?</dt>
                            <dd>{{ migration.emailDetails.isEmail ? 'Yes' : 'No' }}</dd>
                          </dl>
                        </div>
                        <div class="col-md-4">
                          <dl>
                            <dt>Alternate email for communication?</dt>
                            <dd v-if="migration.emailDetails.alternateEmail === 'N/A'">N/A</dd>
                            <dd v-else>
                              {{migration.emailDetails.alternateEmail}}
                              <a href="javascript:void(0)" @click="doCopy(migration.emailDetails.alternateEmail)"><i class="fa fa-copy"></i></a>
                              <!--                                                     <section>-->
                              <!--                                                       <div v-if="migration.status === 'pending' && ( !migration.ackAlternateEmail || ( migration.ackAlternateEmail && !migration.ackAlternateEmail.completedBy))" class="custom-control custom-checkbox p mr-sm-2">-->
                              <!--                                                         <input type="checkbox" required @change="acknowledge(migration, 'alternate_email')" class="custom-control-input" :id="'m' + index + 'complete-alternate-email'"/>-->
                              <!--                                                         <label class="custom-control-label pt-1" :for="'m' + index + 'complete-alternate-email'"></label>-->
                              <!--                                                       </div>-->
                              <!--                                                       <div v-else>-->
                              <!--                                                         <span class="badge badge-primary">{{(migration.ackAlternateEmail && migration.ackAlternateEmail.completedBy) ? migration.ackAlternateEmail.completedBy : 'Acknowledged'}}</span>-->
                              <!--                                                       </div>-->
                              <!--                                                       <div v-if="migration.status !== 'pending' && ( migration.ackAlternateEmail && !migration.ackAlternateEmail.reviewedBy)" class="custom-control custom-checkbox p mr-sm-2">-->
                              <!--                                                         <input type="checkbox" required @change="acknowledge(migration, 'alternate_email')" class="custom-control-input" :id="'m' + index + 'review-alternate-email'"/>-->
                              <!--                                                         <label class="custom-control-label pt-1" :for="'m' + index + 'review-alternate-email'"></label>-->
                              <!--                                                       </div>-->
                              <!--                                                       <div v-else-if="migration.status !== 'pending'">-->
                              <!--                                                         <span class="badge badge-primary">{{(migration.ackAlternateEmail && migration.ackAlternateEmail.reviewedBy) ? migration.ackAlternateEmail.reviewedBy : 'Acknowledged'}}</span>-->
                              <!--                                                       </div>-->
                              <!--                                                     </section>-->
                              <!--                                                     <a href="javascript:void(0)" class="badge badge-primary cursor-pointer" title="Click to Acknowledge"  v-if="migration.status === 'pending' && !migration.ackAlternateEmail" @click="acknowledge(migration.docId, 'alternate_email')">-->
                              <!--                                                           <i class="fa fa-check"></i>-->
                              <!--                                                       </a>-->
                              <!--                                                       <span v-else class="d-block">(Alternate email added to communicate with client)</span>-->
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="h-3" />
                  <div v-if="type !== 'abandoned'" class="row">
                    <div class="col-md-12">
                      <h5 v-if="migration.checkList.length > 0" :class="{'pull-left': migration.handledBy !== ''}"><b>Migration Checklist</b></h5>
                      <button v-if="type !== 'finished' && migration.handledBy !== ''" class="btn btn-primary pull-right" type="button" @click.prevent="showAllSteps = !showAllSteps">
                        {{(showAllSteps) ? 'Show only required steps' : 'Show All Steps'}}
                      </button>
                      <template v-if="migration.handledBy !== ''">
                        <section v-for="(phase, p_index) of migration.checkList" :key="p_index">
                          <section>
                            <!--                                                   <h6 class="text-danger">Phase {{ p_index +1 }}</h6>-->
                            <table class="table table-hover">
                              <!--                                               <thead v-if="p_index === 0">-->
                              <!--                                               <tr>-->
                              <!--                                                 <th>Task</th><th class="text-center">Completed</th>-->
                              <!--                                                 <th class="text-center" v-if="migration.status !== 'pending'">2nd Review</th><th class="text-center">Comments</th>-->
                              <!--                                               </tr>-->
                              <!--                                               </thead>-->
                              <tbody>
                              <tr>
                                <td colspan="4">
                                  <h5 class="text-danger"><b>Phase {{ p_index +1 }}</b></h5>
                                </td>
                              </tr>
                              <tr v-for="(task, task_index) of phase.tasks" :key="'tasks_' + task_index" v-if="showAllSteps || type === 'finished' || task.heading || (type === 'active' && (task.migration || task.required)) || (type === 'review' && (task.review || task.required))">
                                <td class="task-width" v-if="!task.heading" :style="(task.pl) ? 'padding-left: 50px  !important;' : ''">
                                  <template v-if="task.type === 'dropdown'">
                                    <select class="form-control col-md-6" v-model="task.answer" @change="updateChecklist(index, task)" :required="task.required || (migration.status === 'pending' && task.migration) || (migration.status === 'review' && task.review)" :disabled="task.answer && (task.completed || (task.reviewed))">
                                      <option v-for="(opt, d_index) of getDropdownOption(task.text)" :value="opt" :key="d_index">{{opt}}</option>
                                    </select>
                                  </template>
                                  <template v-else>
                                                     <span v-if="task.text.toLowerCase().includes('cloudflare') && task.text.toLowerCase().includes('pause')" class=" cf-status-icons pull-right">
                                                       <a  href="javascript:void(0)" class="mx-2">
                                                           <i :title="(migration.cloudflare.ssl === 'full') ? 'SSL - FULL' : (migration.cloudflare.ssl === 'flexible') ? 'SSL - FLEXIBLE' : 'SSL - Not Active'"
                                                              :class="{'fa fa-lock disabled' : (migration.cloudflare.ssl ===  false || migration.cloudflare.ssl ===  undefined),
                                                          'fa fa-lock mr-3 enabled' : migration.cloudflare.ssl === 'full',
                                                          'fa fa-lock mr-3 yellow' : migration.cloudflare.ssl === 'flexible'}"></i></a>
                                                        <a  href="javascript:void(0)" class="mx-2">
                                                          <i class="my-3" :title="(migration.cloudflare.cf === 'paused') ? 'CF - Paused' : (migration.cloudflare.cf === true) ? 'CF - Active & Un-Paused'  : 'CF - Not Active'"
                                                             :class="{'fa fa-cloud disabled' : (migration.cloudflare.cf === undefined || migration.cloudflare.cf === false),
                                                         'fa fa-cloud yellow' : migration.cloudflare.cf === 'paused',
                                                         'fa fa-cloud enabled': migration.cloudflare.cf === true}"></i>
                                                        </a>
                                                     </span>
                                    <span v-html="(task.text).replace(/\n/g, `<br/>`)"></span>
                                    <span v-if="task.text.toLowerCase().includes('wpo') && task.text.toLowerCase().includes('ftp') && task.text.toLowerCase().includes('php') && task.text.toLowerCase().includes('cloudflare') && task.text.toLowerCase().includes('backup')">
                                                         <a href="javascript:void(0)" @click="openAccountModal(migration)" class="btn btn-sm btn-primary">
                                                           View Account
                                                         </a>
                                                       </span>
                                  </template>
                                </td>
                                <td v-else colspan="4"><b v-html="(task.text).replace(/\n/g, `<br/>`)"></b></td>
                                <td class="text-center" v-if="!task.heading">
                                  <section v-if="loader === 'complete' + index + p_index + task_index">
                                    <div class="loader" style="width: 20px;height: 20px; margin: 0 auto !important;"></div>
                                  </section>
                                  <section v-else>
                                    <div v-if="!task.completed" class="custom-control custom-checkbox p mr-sm-2">
                                      <input type="checkbox" :disabled="migration.status === 'finished'" @change="completeTask(index, p_index, task_index)" class="custom-control-input" :id="type + 'm' + index + 'p' + p_index +'q' + task_index + 'a'"/>
                                      <label class="custom-control-label pt-1" :for="type + 'm' + index + 'p' + p_index +'q' + task_index + 'a'"></label>
                                    </div>
                                    <div v-else>
                                      <span class="badge badge-primary">{{ task.completedBy }}</span>
                                    </div>
                                  </section>
                                </td>
                                <td class="text-center" v-if="!task.heading && migration.status !== 'pending'">
                                  <section v-if="loader === 'review' + index + p_index + task_index">
                                    <div class="loader" style="width: 20px;height: 20px; margin: 0 auto !important;"></div>
                                  </section>
                                  <section v-else>
                                    <div v-if="!task.reviewed" class="custom-control custom-checkbox p mr-sm-2">
                                      <input type="checkbox" :disabled="migration.status === 'finished'" @change="reviewTask(index, p_index, task_index)" class="custom-control-input" :id="type + 'm' + index + 'p' + p_index +'q' + task_index + 'b'" />
                                      <label class="custom-control-label pt-1" :for="type + 'm' + index + 'p' + p_index +'q' + task_index + 'b'"></label>
                                    </div>
                                    <div v-else>
                                      <span class="badge badge-primary">{{ task.reviewedBy }}</span>
                                    </div>
                                  </section>
                                </td>
                                <td class="text-center" v-if="!task.heading">
                                  <button class="btn btn-sm" :class="(task.comments.length > 0)? 'btn-danger' : 'btn-link'" @click.prevent="openCommentModal(index, task)">Comments</button>
                                </td>
                              </tr>
                              </tbody>
                            </table>

                          </section>
                        </section>
                        <template v-if="migration.status !== 'finished'">
                          <div class="row">
                            <div class="col-md-11">
                              <button type="submit" class="btn btn-primary pull-left btn-block">Proceed</button>
                            </div>
                            <div class="col-md-1">
                              <ul class="list-inline ul-m0">
                                <li v-if="loading" class="list-inline-item text-center cf-status-icons text-danger">
                                  <div class="loader" style="width: 20px;height: 20px; margin: 0 auto !important;"></div>
                                </li>
                                <li v-if="type === 'active' && !loading" @click="toggleAbandoned(migration, 'abandoned')" class="list-inline-item text-center cf-status-icons text-danger">
                                  <i class="btn btn-link default fa fa-trash" title="Move to Abandoned"></i>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <b class="text-danger">You must have to check-in to this migration before proceeding <!-- to check list --> </b>
                      </template>
                    </div>
                  </div>
                  <div v-else>
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <ul class="list-inline ul-m0">
                          <li v-if="loading" class="list-inline-item text-center cf-status-icons text-danger">
                            <div class="loader" style="width: 40px;height: 40px; margin: 0 auto !important;"></div>
                          </li>
                          <li v-if="!loading" @click="toggleAbandoned(migration, 'pending')" class="list-inline-item text-center cf-status-icons text-success">
                            <button type="button" class="btn btn-success" @click.prevent="toggleAbandoned(migration, 'pending')" >Move to Active</button>
                          </li>
                          <li v-if="!loading" class="list-inline-item text-center cf-status-icons text-danger">
                            <button type="button" class="btn btn-danger" @click.prevent="deletePermanently(migration)" >Delete Permanently</button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="type !== 'finished'" class="row">
      <div class="col-md-12 text-center">
                <span class="lh-3 pull-left">
                    Page {{this.pageNumber + 1}} of {{ pageCount }}
                </span>
        <section class="dataTables_paginate paging_full_numbers">
          <paginate
              :pageCount="pageCount"
              :clickHandler="goToPage"
              :prevText="'Prev'"
              :nextText="'Next'"
              page-class="page-item"
              prev-class="page-item"
              prev-link-class="page-link"
              next-class="page-item"
              next-link-class="page-link"
              page-link-class="page-link"
              containerClass="pagination">
          </paginate>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import {db} from "@/firebase/init"
import copyButtonMixin from '../../../mixins/copyButtonMixin';
import loginAsMixin from "../../../mixins/loginAsMixin";
import Paginate from 'vuejs-paginate'
import swal from "sweetalert2";
import dateMixin from "../../../mixins/dateMixin";
import adminLogs from "@/mixins/adminLogs";

export default {
  name: "MigrationsList",
  mixins: [dateMixin, copyButtonMixin, loginAsMixin, adminLogs],
  components: { Paginate },
  props: {
    tasks: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      // message: 'Hello,<br><br> As of now, we have started the migration of your website. It is advised that you stop ALL work on the website. You can continue browsing it as normal, though it is possible that any changes you make during this time may be lost.<br><br>Migrations typically take between 1 - 4 hours depending on the size of the website.<br> <br> *** <br><br>If you choose to have your email hosted with BigScoots, please note that your DNS will be changed. In some cases, this may temporarily stop your ability to receive emails in your chosen mail client (i.e. Gmail, Webmail, etc.) if the email being used to create your BigScoots account coincides with your domain email.  Please make sure to visit:<br><br> https://wpo.bigscoots.com/email/<br><br> Here you can setup your email accounts and using the "Client Setup" button, you can reconfigure your mail client if needed.  If any problems you can also use "Check Email" button to use webmail for now to communicate. <br> <br> *** <br><br> Once the migration has been completed we will update you further. In the mean time, if you have any questions or concerns, please feel free to reach out.',
      showRecords: 10,
      pageNumber: 0,
      searchQuery: '',
      searchBy: 'domain',
      loader: null,
      collapseIndex: -1,
      previousTasks: 0,
      updatingCF: false,
      loading: false,
      showAllSteps: false,
      notifying: null,
      message: ''
    }
  },
  computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    user() {
      return this.$store.getters.user;
    },
    searchedTasks () {
      if (this.type === 'finished') {
        return this.tasks
      }
      return this.tasks.filter(acc => {
        return acc.siteDetails.domainName.toLowerCase().includes(this.searchQuery.toLowerCase()) || acc.email.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
    },
    filteredTasks () {
      const start = this.pageNumber * this.showRecords, end = start + this.showRecords;
      return this.searchedTasks.slice(start, end);
    },
    pageCount () {
      let l = parseInt(this.searchedTasks.length), s = parseInt(this.showRecords);
      return Math.ceil(l/s);
    },
    totalTasks () {
      return this.tasks.length
    },
  },
  watch: {
    totalTasks (value) {
      if (this.previousTasks < value) {
        if (this.collapseIndex >= 0) {
          let self = this;
          setTimeout(function () {
            $('#collapse_' + (self.collapseIndex + 1) + self.type).collapse('toggle');
          }, 300)
        }
      }
      this.previousTasks = value;
    },
    showRecords (value) {
      if (this.type === 'finished') {
        this.$parent.page_Size = parseInt(value)
      }
    },
    searchQuery (value) {
      this.pageNumber = 0
      if (this.type === 'finished') {
        this.$parent.searchQuery = value
      }
    },
    searchBy (value) {
      this.pageNumber = 0
      if (this.type === 'finished') {
        this.$parent.searchBy = value
      }
    }
  },
  methods: {
    openTab(value) {
      const inList = this.$parent.selectedTabValues.find(item => item === 'collapse_' + this.type + value.docId);
      if (!inList) {
        this.$parent.selectedTabValues = this.$parent.selectedTabValues.filter(item => !item.includes('collapse_' + this.type));
        this.$parent.selectedTabValues.push('collapse_' + this.type + value.docId);
      } else {
        this.$parent.selectedTabValues = this.$parent.selectedTabValues.filter(item => item !== 'collapse_' + this.type + value.docId);
      }
    },
    getText(data) {
      return data.replace(/<script/g, '').replace(/<script\/>/g, '').replace(/\n/g, `<br/>`)
          .replace(/<img/g, '').replace(/<a/g, '').replace(/<a\/>/g, '').replace(/<link\/>/g, '');
    },
    viewTicket(data) {
      window.open(`https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${data.ticketId}`, '_blank');
    },
    openTempDomainModal(data) {
      this.$parent.$refs.tempDomainModal.load({
        domain: data.siteDetails.domainName,
        uid: data.uid,
      })
    },
    async getStartMigrationMessage(user) {
      this.message = ''
      let ref = await db.collection('presets').where('key', '==', 'migration-starting').where('type', '==', 'email').limit(1).get();
      ref.forEach(el => {
        this.message = el.data().message || ''
      })
      if (this.message) {
        this.message = this.message.replace(/{firstName}/g, user.firstName)
      }
    },
    openPsiModal(domain) {
      console.log(domain)
      this.$parent.$refs.psiModal.load(domain)
    },
    async notifyUser(migration, alreadySent) {
      console.log('%cMigrationsList.vue line:679 this.user', 'color: #007acc;', migration.docId);
      try {
        if (alreadySent) {
          const result = await swal({
            title: "Are you sure?",
            text: `Initial migration reply was already sent. Do you want to resend?`,
            type: "question",
            confirmButtonText: "Yes",
            confirmButtonColor: "#6ACF98",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            cancelButtonColor: "#EE8057"
          });
          if (!result.value) {
            console.log('not sending')
            return
          }
        }
        this.loading = true
        let userRef = await db.collection('users').doc(migration.uid).get()
        userRef = userRef.data()
        await this.getStartMigrationMessage(userRef)
        this.notifying = migration.ticketId
        await this.$http.post('utilities/send-migration-ticket-reply', {
          grant_type: 'token',
          message: this.message,
          status: 'In-Progress',
          ticketId: migration.ticketId,
          name: this.user.firstName + ' ' + this.user.lastName,
          hostBillId: this.user.hostBillId,
        });
        migration.notifyUser = true
        await db.collection('savedMigrations').doc(migration.docId).update({
          notifyUser: true,
          modified: new Date().toISOString()
        });
        swal({
          title: "Success",
          text: 'User has been notified!',
          type: "success",
        });
      } catch (e) {
        console.log(e.toString());
        console.log('Error in notifying user');
        swal({
          title: "Error",
          text: 'Error in notifying user!',
          type: "error",
        });
      } finally {
        this.loading = false
      }
      this.notifying = null
    },
    getLink(link) {
      if (link && (link.includes('http://') || link.includes('https://'))) {
        return link;
      } else {
        const newLink = 'https://' + link;
        return newLink
      }
    },
    async updateReviewCFStatus() {
      this.updatingCF = true;
      try {
        await this.$http.post('utilities/updateCFStatus', {
          grant_type: 'token',
        });
        swal({
          title: "Success",
          text: 'CF status has been updated for migrations under review!',
          type: "success",
        });
        this.addLog({message: "CF status has been updated for migrations under review!", level: "info"}
        )
      } catch (e) {
        swal({
          title: "Error",
          text: 'Error in updating CF status for migrations under review!',
          type: "error",
        });
        this.addLog(
            {
              message: "Error in updating CF status for migrations under review!", level: "danger"
            })

      }
      this.updatingCF = false;
    },
    async toggleAbandoned(migration, status) {
      const result = await swal({
        title: "Are you sure?",
        text: `Please confirm that you would like to move this migration to ${(status === 'pending') ? 'Active' : 'Abandoned'}.`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      });
      if (result.value) {
        this.loading = true;
        try {
          await db.collection('savedMigrations').doc(migration.docId).update({
            status,
            modified: new Date().toISOString()
          });
          try {
            const keyword = (status === 'pending') ? 'Active' : 'Abandoned';
            const from = (status === 'pending') ? 'Abandoned' : 'Active';
            const msg = `${migration.siteDetails.domainName} has been migrated from ${from} to ${keyword} by ${this.user.firstName} ${this.user.lastName}.`
            await this.$http.post('utilities/send-slack-notification', {
              grant_type: 'token',
              msg,
              showButton: false,
            });
            await this.addLog({
              uid: this.migration.uid,
              primaryPlan: this.formatPrimaryDomainName(this.migration.primaryPlan),
              message: `User has moved migration ${this.domain} from ${from} to ${keyword}.`,
              level: "info"
            })
            try {
              await this.removeAdminActiveTask({taskId: this.migration.docId});
            } catch (e) {
              console.log(e.toString())
            }
            try {
              if (this.type === 'finished') {
                await this.$parent.switchTab('resolveMigrations')
              }
            } catch (e) {
              console.log(e.toString());
            }
          } catch (e) {
            console.log(e.toString());
            this.addLog({
              message: e.toString(),
              level: "danger"
            })
          }
        } catch (e) {
          swal({
            title: "Error",
            text: `Error in moving migrations under ${(status === 'pending') ? 'Active' : 'Abandoned'}!`,
            type: "error",
          });
        }
        this.addLog({
          message: `Error in moving migrations under ${(status === 'pending') ? 'Active' : 'Abandoned'}`,
          level: "danger"
        })
        this.loading = false;
      }
    },
    formatPrimaryDomainName(value) {
      const match = value.match(/(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9]+)+)/i);

      // If there's a match, return the domain group
      if (match && match.length > 1) {
        return match[1];
      } else {
        return 'Account Based Operation'; // Return null if no match found
      }
    },
    async deletePermanently(migration) {
      const result = await swal({
        title: "Are you sure?",
        text: `Please confirm that you would like to remove  this migration permanently.`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      });
      if (result.value) {
        this.loading = true;
        try {
          await db.collection('savedMigrations').doc(migration.docId).delete();
          swal({
            title: "Deleted!",
            text: 'Migration has been deleted permanently!',
            type: "success",
          });
          try {
            const msg = `${migration.siteDetails.domainName} has been deleted permanently by *${this.user.firstName}* *${this.user.lastName}*.`
            await this.$http.post('utilities/send-slack-notification', {
              grant_type: 'token',
              msg,
              showButton: false,
            });

            await this.addLog({
              uid: this.migration.uid,
              primaryPlan: this.formatPrimaryDomainName(this.migration.primaryPlan),
              message: `Migration ${this.domain} has been deleted permanently.`,
              level: "info"
            })
            try {
              if (this.type === 'finished') {
                await this.$parent.switchTab('resolveMigrations')
              }
            } catch (e) {
              console.log(e.toString());
            }
          } catch (e) {
            console.log(e.toString());
            this.addLog({
              message: e.toString(),
              level: "danger"
            })
          }
        } catch (e) {
          swal({
            title: "Error",
            text: `Error in deleting this migration!`,
            type: "error",
          });
          this.addLog({
            message: "Error in deleting this migration",
            level: "danger"
          })
        }
        this.loading = false;
      }
    },
    openAccountModal(migration) {
      this.$parent.$refs.accountModal.load(migration)
    },
    finishBtnDisabled(migration) {
      return !(((migration.additionalDetails.membershipOrECommerce && migration.ackMembership) || !migration.additionalDetails.membershipOrECommerce)
          && ((migration.additionalDetails.collaborators && migration.additionalDetails.collaborators.length > 0 && migration.ackCollaborator) ||
              !migration.additionalDetails.collaborators || migration.additionalDetails.collaborators.length <= 0)
          && (migration.emailDetails.alternateEmail !== 'N/A' && migration.ackAlternateEmail || (migration.emailDetails.alternateEmail === 'N/A'))
          && (migration.additionalDetails.specialInstructions !== '' && migration.ackNotes && migration.additionalDetails.specialInstructions !== 'N/A') ||
          migration.additionalDetails.specialInstructions === 'N/A' || migration.additionalDetails.specialInstructions === '')
    },
    changeCustomStatus(migration) {
      this.$parent.$refs.customStatus.load(migration)
    },
    async acknowledgeNote(migration, note, type) {
      if (type === 'review') {
        note.reviewedBy = this.user.firstName + ' ' + this.user.lastName
      } else {
        note.completedBy = this.user.firstName + ' ' + this.user.lastName
      }
      await db.collection('savedMigrations').doc(migration.docId).update({
        notes: migration.notes,
        modified: new Date().toISOString()
      })
    },
    async deleteMigrationNote(notes, docId, index) {
      notes.splice(index, 1)
      await db.collection('savedMigrations').doc(docId).update({
        notes,
        modified: new Date().toISOString()
      })
    },
    async acknowledge(migration, ack_for) { // migration.status === 'pending' || migration.status === 'review',
      console.log(migration)
      console.log(ack_for)
      if (migration.status === 'pending') {
        switch (ack_for) {
          case 'membership' :
            await db.collection('savedMigrations').doc(migration.docId).update({
              ackMembership: {
                completedBy: this.user.firstName + ' ' + this.user.lastName
              },
              modified: new Date().toISOString()
            })
            break;
          case 'collaborator' :
            await db.collection('savedMigrations').doc(migration.docId).update({
              ackCollaborator: {
                completedBy: this.user.firstName + ' ' + this.user.lastName
              },
              modified: new Date().toISOString()
            })
            break;
          case 'alternate_email' :
            await db.collection('savedMigrations').doc(migration.docId).update({
              ackAlternateEmail: {
                completedBy: this.user.firstName + ' ' + this.user.lastName
              },
              modified: new Date().toISOString()
            })
            break;
          case 'additional_detail' :
            await db.collection('savedMigrations').doc(migration.docId).update({
              ackAdditionalDetail: {
                completedBy: this.user.firstName + ' ' + this.user.lastName
              },
              modified: new Date().toISOString()
            })
            break;
          case 'ackNotes' :
            await db.collection('savedMigrations').doc(migration.docId).update({
              ackNotes: {
                completedBy: this.user.firstName + ' ' + this.user.lastName
              },
              modified: new Date().toISOString()
            })
            break;
          default:
            break;
        }
      } else {
        switch (ack_for) {
          case 'membership' :
            migration.ackMembership.reviewedBy = this.user.firstName + ' ' + this.user.lastName
            await db.collection('savedMigrations').doc(migration.docId).update({
              ackMembership: migration.ackMembership,
              modified: new Date().toISOString()
            })
            break;
          case 'collaborator' :
            migration.ackCollaborator.reviewedBy = this.user.firstName + ' ' + this.user.lastName
            await db.collection('savedMigrations').doc(migration.docId).update({
              ackCollaborator: migration.ackCollaborator,
              modified: new Date().toISOString()
            })
            break;
          case 'alternate_email' :
            migration.ackAlternateEmail.reviewedBy = this.user.firstName + ' ' + this.user.lastName
            await db.collection('savedMigrations').doc(migration.docId).update({
              ackAlternateEmail: migration.ackAlternateEmail,
              modified: new Date().toISOString()
            })
            break;
          case 'additional_detail' :
            migration.ackAdditionalDetail.reviewedBy = this.user.firstName + ' ' + this.user.lastName
            await db.collection('savedMigrations').doc(migration.docId).update({
              ackAdditionalDetail: migration.ackAdditionalDetail,
              modified: new Date().toISOString()
            })
            break;
          case 'ackNotes' :
            migration.ackNotes.reviewedBy = this.user.firstName + ' ' + this.user.lastName
            await db.collection('savedMigrations').doc(migration.docId).update({
              ackNotes: migration.ackNotes,
              modified: new Date().toISOString()
            })
            break;
          default:
            break;
        }
      }
      console.log(migration)
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum - 1;
    },
    async checkInMigration(migration) {

      await db.collection('savedMigrations').doc(migration.docId).update({
        handledBy: this.user.firstName + ' ' + this.user.lastName,
        handledByEmail: this.user.email,
        modified: new Date().toISOString()
      })
      this.addLog({
        message: "Checking in migration",
        level: "info"
      })
      if (migration.ticketId) {
        try {
          await this.$http.post('/host-bill/add-ticket-tag', {
            ticketId: migration.ticketId,
            grant_type: 'token',
            tag: `${this.user.firstName} ${this.user.lastName}`
          })
          await this.$http.post('/host-bill/update-ticket-status', {
            ticketNumber: migration.ticketId,
            grant_type: 'token',
            status: 'In-Progress',
            fromMigration: true
          })
        } catch (e) {
          console.log(e.toString())
        }
      }
      try {
        const msg = `*${this.user.firstName}* *${this.user.lastName}* has checked into migration: ${migration.siteDetails.domainName}.`
        await this.$http.post('utilities/send-slack-notification', {
          grant_type: 'token',
          msg,
          showButton: false,
        });
      } catch (e) {
        console.log(e.toString());
      }
      const domain = migration.domainDetails.domainRegistrarDetails.domainName;
      const data = {
        ticketId: migration.ticketId,
        taskId: migration.docId,
        type: 'info',
        actionType: 'Migration Task',
        message: `Migration for domain ${this.domainAdjustment(domain)} has been checked in by ${this.user.firstName} ${this.user.lastName}.`,
        customer: {
          email: migration.email,
          domain: domain,
        }
      }
      await this.addRecentActivity({...data});
      await this.addToAdminActiveTask({...data});
    },
    async checkOutMigration(migration) {
      this.addLog({
        message: "Checking out migration",
        level: "info"
      })
      await db.collection('savedMigrations').doc(migration.docId).update({
        handledBy: '',
        modified: new Date().toISOString()
      })
      try {
        const msg = `*${this.user.firstName}* *${this.user.lastName}* has checked out from migration: ${migration.siteDetails.domainName}.`
        await this.$http.post('utilities/send-slack-notification', {
          grant_type: 'token',
          msg,
          showButton: false,
        });
        const domain = migration.domainDetails.domainRegistrarDetails.domainName;
        const data = {
          ticketId: migration.ticketId,
          taskId: migration.uid,
          type: 'info',
          actionType: 'Migration Task',
          message: `Migration for domain ${this.domainAdjustment(domain)} has been checked in by ${this.user.firstName} ${this.user.lastName}.`,
          customer: {
            email: migration.email,
            domain: domain,
          }
        }
        await this.addRecentActivity({...data})
        try {
          await this.removeAdminActiveTask({taskId: migration.docId})
        } catch (e) {
          console.log(e.toString())
        }
      } catch (e) {
        console.log(e.toString());
      }
    },
    async finishMigration(migration, index) {
      console.log(migration.sendTicketReply)
      this.$parent.$refs.ticketMessage.load(migration, index, this.type)
    },
    openNotesModal(migration) {
      this.$parent.$refs.notes.load(migration)
    },
    async completeTask(m_index, p_index, t_index) {
      this.loader = 'complete' + m_index + p_index + t_index
      this.filteredTasks[m_index].checkList[p_index].tasks[t_index].completed = true
      this.filteredTasks[m_index].checkList[p_index].tasks[t_index].completedBy = this.user.firstName + ' ' + this.user.lastName
      await this.updateChecklist(m_index)
      this.loader = null
    },
    async reviewTask(m_index, p_index, t_index) {
      this.loader = 'review' + m_index + p_index + t_index
      this.filteredTasks[m_index].checkList[p_index].tasks[t_index].reviewed = true
      this.filteredTasks[m_index].checkList[p_index].tasks[t_index].reviewedBy = this.user.firstName + ' ' + this.user.lastName
      await this.updateChecklist(m_index)
      this.loader = null
    },
    openCommentModal(m_index, task) {
      let commentObject = {
        m_index,
        comments: task.comments,
        status: this.filteredTasks[m_index].status
      }
      this.$parent.$refs.comment.load(commentObject)
    },
    async updateChecklistComments(object) {
      await this.updateChecklist(object.m_index)
    },
    async updateChecklist(index, task) {
      if (task && !task.answer) {
        return;
      }
      await db.collection('savedMigrations').doc(this.filteredTasks[index].docId).update({
        checkList: this.filteredTasks[index].checkList,
        modified: new Date().toISOString()
      })
    },
    getDropdownOption(text) {
      return text.split('\n')
    }
  }
}
</script>

<style scoped lang="scss">
.notes-section {
  background-color: #ef8057;
  color: white;
  border-radius: 3px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;

  hr {
    border-top: 1px solid rgba(255, 255, 255, .5);
  }
}

table {
  tr {
    .task-width {
      width: 70%;
    }

    td {
      /deep/ p {
        margin: 0 !important;
      }
    }
  }
}

hr {
  &.h-3 {
    border-top: 3px solid rgba(0, 0, 0, .1);
  }
}

.pagination {
  display: inline-flex !important;
}

.cf-status-icons {
  i {
    font-size: 25px;
    margin: 0 !important;

    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }

    &.default {
      color: currentColor;
    }

    &:hover {
      background-color: transparent !important;
      color: currentColor !important;
    }
  }
}

.cpy-btn {
  margin: 0;
}

.fs-10 {
  font-size: 10px;
}

.h-43 {
  height: 43px;
}

.domain-card {
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;

  &:hover {
    box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
  }

  .collapse-btn {
    margin-top: 0.5rem !important;
  }

  .domain-head {
    display: flex;
    justify-content: space-between;

    .h5-m0 {
      margin: 0;
    }

    .ul-m0 {
      margin: 0;
    }
  }

  .domain-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .badge {
      text-transform: none !important;
    }
  }
}

.bl-bt {
  display: flex;
  align-items: flex-end;

  button {
    margin: 0 !important;
  }
}

.cursor-pointer {
  cursor: pointer;
}

pre {
  display: inline-block;
  margin-bottom: 0px;
}
</style>
